<template>
    <section id="all-email-logs" class="all-cases-view" v-loading="loading">
      <div class="container-small-table">
        <div class="listings-navbar">
          <el-row>
            <el-col :lg="24">
              <ul
                class="d-flex flex-wrap justify-content-end list-items-group-15"
              >
                <li v-if="isAbletoAddInsurance">
                  <el-button class="btn button-with-icon" @click="addInsurance()">
                    <span class="mr-8">
                      <img
                        src="@/assets/images/icons/plus-icon.svg"
                        alt="icon"
                        class="inactive"
                      />
                      <img
                        src="@/assets/images/icons/plus-icon-white.svg"
                        alt="icon"
                        class="active"
                      />
                    </span>
                    <span>ADD INSURANCE</span>
                  </el-button>
                </li>
                <li>                  
                  <div class="form-element input-with-icon search-input-lg">
                    <el-input
                      placeholder="Search"
                      v-model="search_string"
                      @input="getAutoCompleteCases()"
                      :clearable="true"
                    ></el-input>
                    <span>
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid icon"
                      />
                    </span>
                  </div>
                </li>                
                <li>
                  <el-button
                    class="btn button-with-icon"
                    @click="onInsuranceExport"
                  >
                    <span class="mr-8">
                      <img
                        src="@/assets/images/icons/export-icon-with-bg-blue.svg"
                        alt="icon"
                        class="inactive"
                      />
                      <img
                        src="@/assets/images/icons/export-icon-white.svg"
                        alt="icon"
                        class="active"
                      />
                    </span>
                    <span>Export</span>
                  </el-button>
                </li>
              </ul>
            </el-col>
          </el-row>
        </div>
  
        <div class="primary-content-view-new">
          <div
            class="listings listings__table listings__all-cases"
            id="all-cases-listings"
          >
            <el-table
              :data="getInsurances.data"
              height="calc(100vh - 200px)"
              @sort-change="onChangeSort"
              :default-sort="{
                prop: orderBy,
                order: orderType == 'asc' ? 'ascending' : 'descending',
              }"
            >
              <el-table-column
                label="INSURANCE NAME"
                min-width="200"
                prop="case_id.accession_id"
                ><template v-slot="scope">{{
                  scope.row.name ? scope.row.name : "--"
                }}</template>
              </el-table-column>
              <el-table-column
                label="STATUS"
                min-width="160"
                prop="case_id.accession_id"
                ><template v-slot="scope">
                  <div class="column-status">
                    <el-tag :type="getStatusType(scope.row.status)">{{
                      scope.row.status.split("_").join(" ")
                    }}</el-tag>  
                  </div>
              </template>
              </el-table-column>
              <el-table-column
                label="PAYOR CODE"
                min-width="130"
                prop="case_id.accession_id"
                ><template v-slot="scope">{{
                  scope.row.payor_electronic_id ? scope.row.payor_electronic_id : "--"
                }}</template>
              </el-table-column>
              <el-table-column
                label="WAVE CODE"
                min-width="130"
                prop="case_id.accession_id"
                ><template v-slot="scope">{{
                  scope.row.insurance_verification_code ? scope.row.insurance_verification_code : "--"
                }}</template>
              </el-table-column>
              <el-table-column
                label="ACTIONS"
                width="100"
                prop=""
                >
                <template v-slot="scope">
                <ul class="listings__action-buttons">
                  <li v-if="isAbletoAddInsurance">
                    <el-button
                      class="view-button"
                      title="Edit Insurance"
                      @click="editInsurance(scope.row._id)"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/edit-active.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/edit-deactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li v-if="isAbletoAddInsurance">
                    <el-button
                      class="view-button"
                      title="Remove Insurance"
                      @click="removeInsurance(scope.row._id)"
                    >
                      <img
                        class="testreports-active"
                        src="@/assets/images/icons/actions/test-delect-active.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                </ul>
              </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="listings listings__pagination">
          <el-pagination
            v-model:currentPage="page"
            v-model:page-size="pageSize"
            :page-sizes="[25, 50, 75, 100]"
            layout=" prev, pager, next, jumper, sizes ,total"
            :total="getInsurances.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </section>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
  import FilterHelper from "@/mixins/FilterHelper";
  import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
  export default {
    components: {},
    computed: {
      ...mapGetters("insurances", ["getInsurances","getInsuranceReport","getInsuranceRemoveStatus"]),
      getStatusType() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "ACTIVE") {
          return "success";
        } else if (status == "INACTIVE") {
          return "danger";
        }
      };
    },
    },
    mounted() {
      this.setQueryParamsData();
      this.fetchInsurances();
    },
    data() {
      return {
        search_string: "",
        page: 1,
        pageSize: 25,
        orderBy: "",
        orderType: "",
        loading: false,
        logsTable: {},
        searchCaseLoading: false,
        allCases: [],
        searchCaseId: "",
      };
    },
  
    mixins: [UserPermissionsHelper, FilterHelper],
  
    methods: {
      async removeInsurance(insuranceId) {
        try {
          this.loading = true;
          let params = {
            insurance_id:insuranceId
          }
          await this.$store.dispatch("insurances/removeInsuranceById", params);
          this.loading = false;
          if (this.getInsuranceRemoveStatus) {
            successNotification("Insurance deleted successfully");
            await this.fetchInsurances();
          } else {
            errorNotification("Error at deleting insurance");
          }
        } catch (err) {
          this.loading = false;
          console.error(err);
        }
      },
      async onInsuranceExport(){
        try {
          let params = {}
          if (this.search_string) {
            params.search_string = this.search_string;
          }
          await this.$store.dispatch("insurances/exportInsurances",params)
          if(this.getInsuranceReport){
            successNotification("Insurance details downloaded successfully")
          } else {
            errorNotification("Error in downloading insurances")
          }
        } catch(err){
          console.log(err)
        }
      },
      editInsurance(insurance){
        this.$router.push({
          name:"UpdatedInsurances",
          params:{insurance_id:insurance}
        })
      },
      addInsurance(){
        this.$router.push({
          name:"AddInsurances"
        })
      },
      getAutoCompleteCases() {
        setTimeout(() => {
          this.page = 1;
          this.fetchInsurances();
        }, 600);
      },
      onChangeSort({ order, prop }) {
        if (order && prop) {
          this.orderBy = prop;
          this.orderType = order == "ascending" ? "asc" : "desc";
        } else {
          this.orderBy = "created_at";
          this.orderType = "DESC";
        }
        this.fetchInsurances();
      },
      handleSizeChange(size) {
        this.pageSize = size;
        this.page = 1;
  
        this.fetchInsurances();
      },
      handleCurrentChange(page) {
        this.page = page;
  
        this.fetchInsurances();
      },
      prepareParams() {
        const params = {
          page: this.page,
          limit: this.pageSize,
        };
        if (this.search_string) {
          params.search_string = this.search_string;
        }
        if (this.orderBy && this.orderType) {
          params.order_by = this.orderBy.toLowerCase();
          params.order_type = this.orderType;
        } 
        return params;
      },
  
      setQueryParamsData() {
        this.page = this.$route.query.selectedPage
          ? parseInt(this.$route.query.selectedPage)
          : 1;
        this.pageSize = this.$route.query.selectedPageSize
          ? parseInt(this.$route.query.selectedPageSize)
          : 25;
        if (this.$route.query.selectedString) {
          this.search_string = this.$route.query.selectedString;
        }
        if (this.$route.query.selectedOrderBy) {
          this.orderBy = this.$route.query.selectedOrderBy;
        }
        if (this.$route.query.selectedOrderType) {
          this.orderType = this.$route.query.selectedOrderType;
        }
      },
      updateQueryParams(params) {
        let selectedParams = {
          selectedPage: params.page,
          selectedString: params.search_string,
          selectedPageSize: params.limit,
          selectedOrderBy: params.order_by,
          selectedOrderType: params.order_type,
        };
        this.updateQueryParam(this.$route.name, selectedParams);
      },
      async fetchInsurances() {
        try {
          this.loading = true;
          let params = this.prepareParams();
          await this.$store.dispatch("insurances/fetchAllInsurances", params);
          this.updateQueryParams(params);
          this.logsTable = JSON.parse(JSON.stringify(this.getInsurances));
          this.loading = false;
        } catch (err) {
          this.loading = false;
          console.log(err);
        }
      },
    },
  };
  </script>
  
  <style lang="scss">
  #all-email-logs {
    .listings__table .el-table table tbody tr td.el-table__cell {
      padding: 2.7px;
    }
  }
  </style>
  <style lang="scss"></style>
  